import {
  WalletTopupRankingItemResponse,
  WalletTopupRankingsSummaryResponse,
} from "../../../domain/models/accounting/wallet-topup-rankings.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isNullableFiniteNumber = (value: unknown): value is number | null =>
  value === null || isFiniteNumber(value);

const isString = (value: unknown): value is string => typeof value === "string";

const isItem = (value: unknown): value is WalletTopupRankingItemResponse =>
  isRecord(value) &&
  isFiniteNumber(value["position"]) &&
  isNullableFiniteNumber(value["externalMemberId"]) &&
  isString(value["memberName"]) &&
  isString(value["operationNumber"]) &&
  isFiniteNumber(value["amount"]) &&
  isNullableFiniteNumber(value["topupCount"]);

export function isWalletTopupRankingsSummaryResponse(
  value: unknown,
): value is WalletTopupRankingsSummaryResponse {
  return isRecord(value) &&
    isFiniteNumber(value["idCompany"]) &&
    isFiniteNumber(value["idCurrency"]) &&
    isFiniteNumber(value["idPeriod"]) &&
    isFiniteNumber(value["idAccountingDay"]) &&
    isString(value["calculationDate"]) &&
    isString(value["updatedAt"]) &&
    Array.isArray(value["items"]) &&
    value["items"].every(isItem) &&
    isFiniteNumber(value["limit"]) &&
    isFiniteNumber(value["offset"]) &&
    typeof value["hasNext"] === "boolean";
}
